import './Series.scss'
import { useContext, useEffect } from 'react'
import { SeriesContext } from '../../utils/SeriesContext'
import { Link } from 'react-router-dom'


function Series() {

    const { seriesList, handleSelectedSerie } = useContext(SeriesContext);
    
    useEffect(() => {
            handleSelectedSerie('');  
    }, [handleSelectedSerie]);

    /*-------------
    ----- JSX -----
    -------------*/

    return (
        <section className='seriesSection'>
            <ul className='seriesSection_serieList'>
                {seriesList.map((serie) => (
                        <li className='seriesSection_serieList_item' key={serie._id}>
                            <Link to={serie._id ? `/works/${serie._id}`:"*"}>
                                <img className='seriesSection_serieList_item_image' src={serie.images[serie.mainImageIndex].imageUrl} alt={serie.images[serie.mainImageIndex].imageUrl}/>
                                <h3 className='seriesSection_serieList_item_title'>{serie.title}</h3>
                            </Link>
                        </li>
                ))}
            </ul>
        </section>
    )
}

export default Series